import React from 'react';
import MdiIcon from '@mdi/react';
import { IconProps } from '@mdi/react/dist/IconProps';

export const Icon = (props: IconProps) => {
	return <MdiIcon {...props} size={props.size || 1} />;
};
